const PANELS = {
    Projects(vm) {
        const ctx = vm
        return {
            component: 'OrganizationProjectsDrawerPanel',
            props: {
                search: ctx.drawerSearch,
                sortBy: ctx.projectsSortBy,
                sortDirection: ctx.projectsSortDirection,
                sortOptions: ctx.projectsSortOptions,
                sortDirectionOptions: ctx.sortDirectionOptions,
            },
            on: {
                create: ctx.handleCreate,
                'apply-search': ctx.applySearch,
                'apply-sort': ctx.applyProjectsSort,
                'update:search': (value) => { ctx.drawerSearch = value },
                'update:sortBy': (value) => { ctx.projectsSortBy = value },
                'update:sortDirection': (value) => { ctx.projectsSortDirection = value },
            },
        }
    },
    Invitations(vm) {
        const ctx = vm
        return {
            component: 'OrganizationInvitationsDrawerPanel',
            props: {
                availableInvitations: ctx.availableInvitations,
            },
            on: {
                create: ctx.handleCreate,
            },
        }
    },
    Notifications(vm) {
        const ctx = vm
        return {
            component: 'OrganizationNotificationsDrawerPanel',
            props: {
                search: ctx.drawerSearch,
                alreadySeen: ctx.notificationsAlreadySeen,
                startDate: ctx.notificationsStartDate,
                endDate: ctx.notificationsEndDate,
            },
            on: {
                'apply-search': ctx.applySearch,
                'visibility-change': ctx.handleNotificationsVisibility,
                'start-date-change': ctx.handleNotificationsStartDateChange,
                'end-date-change': ctx.handleNotificationsEndDateChange,
                'update:search': (value) => { ctx.drawerSearch = value },
            },
        }
    },
}

export const organizationContextDrawerRoutes = Object.freeze(Object.keys(PANELS))

export function getOrganizationContextDrawerPanel(vm) {
    const factory = PANELS[vm.routeName]
    if (!factory) return { component: null, props: {}, on: {} }
    return factory(vm)
}
